
const getEnv = () => {
    if (window.location.hostname.indexOf("staging") > -1 || window.location.hostname.indexOf("dev") > -1) {
        return "staging";
    } else if (window.location.hostname.indexOf("localhost") > -1) {
        return "dev";
    } else {
        return "prod";
    }
};

const getMyIlliniUrl = () => {
    var env = getEnv();
    if (env == "staging") { return "https://dev.myillini.illinois.edu" }
    if (env == "dev") { return "https://dev.myillini.illinois.edu" }
    if (env == "prod") { return "https://myillini.illinois.edu" }
};

const getAPIUrl = () => {
    var env = getEnv();
    if (env == "staging") { return `https://${window.location.hostname}` }
    if (env == "dev") { return "https://localhost:5001" }
    if (env == "prod") { return `https://${window.location.hostname}` }
};

const getThisUrl = () => {
    return getAPIUrl();
};

const getSelfServiceUrl = () => {
    var env = getEnv();
    if (env == "staging") { return "https://webqa.admin.uillinois.edu/ssa/servlet/SelfServiceLogin?appName=edu.uillinois.aits.SelfServiceLogin&dad=BANQA1&target=" }
    if (env == "dev") { return "https://webqa.admin.uillinois.edu/ssa/servlet/SelfServiceLogin?appName=edu.uillinois.aits.SelfServiceLogin&dad=BANQA1&target=" }
    if (env == "prod") { return "https://webprod.admin.uillinois.edu/ssa/servlet/SelfServiceLogin?appName=edu.uillinois.aits.SelfServiceLogin&dad=BANPROD1&target=" }
};

const getSelfServiceXeUrl = () => {
    var env = getEnv();
    if (env == "staging") { return "https://go.illinois.edu/RegisterForClasses" }
    if (env == "dev") { return "https://go.illinois.edu/RegisterForClasses" }
    if (env == "prod") { return "https://go.illinois.edu/RegisterForClasses" }
};

const getSelfServiceGradesUrl = () => {
    var env = getEnv();
    if (env == "staging") { return "https://go.illinois.edu/ViewGrades" }
    if (env == "dev") { return "https://go.illinois.edu/ViewGrades" }
    if (env == "prod") { return "https://go.illinois.edu/ViewGrades" }
};

const getSelfServiceProfileUrl = () => {
    var env = getEnv();
    if (env == "staging") {return "https://go.illinois.edu/UpdatePersonInfo" }
    if (env == "dev") { return "https://go.illinois.edu/UpdatePersonInfo" }
    if (env == "prod") { return "https://go.illinois.edu/UpdatePersonInfo" }
};

const getSelfServiceAccountUrl = () => {
    var env = getEnv();
    if (env == "staging") { return "https://go.uillinois.edu/ViewMyAccountDetails" }
    if (env == "dev") { return "https://go.uillinois.edu/ViewMyAccountDetails" }
    if (env == "prod") { return "https://go.uillinois.edu/ViewMyAccountDetails" }
};
export { getEnv, getAPIUrl, getMyIlliniUrl, getThisUrl, getSelfServiceUrl, getSelfServiceXeUrl, getSelfServiceGradesUrl, getSelfServiceProfileUrl, getSelfServiceAccountUrl }